import { FC, useMemo } from 'react'

import { IIconProps } from '../IIconProps'

export const PiePercantageIcon: FC<IIconProps> = ({
  width = 24,
  height = 24,
  viewBox,
  percent = 0,
}) => {
  const radius = 120
  const strokeWidth = radius * 0.1
  const center = 128

  // Normalize percent to 0-100 range
  const normalizedPercent = Math.max(0, Math.min(100, percent))

  // Calculate pie slice path
  const piePath = useMemo(() => {
    if (normalizedPercent === 0) return ''
    if (normalizedPercent >= 100) {
      // Full circle
      return `M ${center} ${center - radius}
              A ${radius} ${radius} 0 1 1 ${center - 0.01} ${center - radius}
              Z`
    }

    const angle = (normalizedPercent / 100) * 360
    const angleRad = ((angle - 90) * Math.PI) / 180
    const startAngleRad = (-90 * Math.PI) / 180

    const startX = center + radius * Math.cos(startAngleRad)
    const startY = center + radius * Math.sin(startAngleRad)
    const endX = center + radius * Math.cos(angleRad)
    const endY = center + radius * Math.sin(angleRad)

    const largeArcFlag = angle > 180 ? 1 : 0

    return `M ${center} ${center}
            L ${startX} ${startY}
            A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}
            Z`
  }, [normalizedPercent, center, radius])

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox || '0 0 256 256'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background circle (gray) */}
      <circle cx={center} cy={center} r={radius} fill="#E8E8E8" />
      {/* Pie slice (progress) */}
      {normalizedPercent > 0 && <path d={piePath} fill="#0078D4" />}
      {/* Border circle */}
      <circle
        cx={center}
        cy={center}
        r={radius}
        stroke="#004A84"
        strokeWidth={strokeWidth}
        fill="none"
      />
    </svg>
  )
}
